WW.ajaxbooking = function ($) {
//    $(function() {
//    alert('ajax booking start');
    $('#test_ajax_post').on('click', function () {

        var post_id = jQuery(this).data('id');
        var ajaxUrl = '/wp-admin/admin-ajax.php'; // TODO prepend with context root
        jQuery.ajax({
            url: ajaxUrl,
            type: 'post',
            data: {
                action: 'test_ajax_post',
                post_id: post_id
            },
            success: function (response) {
                alert('response after test_ajax_post');
            }
        });
        return false;
    });
//    });
    return this;
};